import React from 'react';
import { IMaskInput } from 'react-imask';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const CvvMask = React.forwardRef<HTMLInputElement, CustomProps>(
  function CvvMask(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="0000"
        inputRef={ref}
        unmask={false}
        onAccept={(value: string) => onChange({ target: { name: props.name, value } })}
      />
    );
  },
);

export default CvvMask;
